import { useState, type FormEvent } from "react";
import { CheckCircle2 } from "lucide-react";
import { trpc } from "../lib/trpc-client";

export function WaitlistForm(): JSX.Element {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "submitting" | "done" | "error">("idle");

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setStatus("submitting");
    try {
      await trpc.waitlist.join.mutate({ email });
      setStatus("done");
    } catch {
      setStatus("error");
    }
  }

  if (status === "done") {
    return (
      <div className="mx-auto max-w-sm rounded-2xl bg-surface-container-lowest p-md text-center shadow-bloom-lg ring-1 ring-outline-variant/30 sm:p-lg">
        <CheckCircle2 className="mx-auto h-10 w-10 text-secondary" aria-hidden="true" />
        <p className="mt-4 font-headline text-headline-md text-on-surface">Du bist auf der Liste!</p>
        <p className="mt-2 font-body text-body-md text-on-surface-variant">
          Wir melden uns bei dir, sobald Welope startet.
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-sm rounded-2xl bg-surface-container-lowest p-md shadow-bloom-lg ring-1 ring-outline-variant/30 sm:p-lg">
      <p className="font-headline text-headline-md leading-tight text-on-surface">
        Trag dich für die Warteliste ein
      </p>
      <p className="mt-2 font-body text-body-md text-on-surface-variant">
        Welope ist noch nicht öffentlich — wir schreiben dir, sobald es losgeht.
      </p>
      <form className="mt-5 flex flex-col gap-3" onSubmit={handleSubmit}>
        <label htmlFor="waitlist-email" className="sr-only">
          E-Mail-Adresse
        </label>
        <input
          id="waitlist-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="deine@email.de"
          className="h-12 w-full rounded-xl border border-outline-variant bg-surface-bright px-4 font-body text-body-md text-on-surface transition-all focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary"
        />
        {status === "error" && (
          <p className="font-body text-body-sm text-secondary" role="alert">
            Da ist etwas schiefgelaufen — versuch's gleich nochmal.
          </p>
        )}
        <button type="submit" disabled={status === "submitting"} className="btn-primary w-full">
          {status === "submitting" ? "Einen Moment…" : "Auf die Warteliste"}
        </button>
      </form>
    </div>
  );
}
